import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const MachineManagementDetails = () => {
  const { id } = useParams();
  const [machine, setMachine] = useState(null);
  const [newOption, setNewOption] = useState({
    name_en: "",
    name_fr: "",
    name_de: "",
    name_it: "",
    name_es: "",
    value_en: "",
    value_fr: "",
    value_de: "",
    value_it: "",
    value_es: "",
  });
  const [newAdvantage, setNewAdvantage] = useState({
    description_en: "",
    description_fr: "",
    description_de: "",
    description_it: "",
    description_es: "",
  });
  const [newTechnicalCharacteristic, setNewTechnicalCharacteristic] = useState({
    name_en: "",
    name_fr: "",
    name_de: "",
    name_it: "",
    name_es: "",
    value_en: "",
    value_fr: "",
    value_de: "",
    value_it: "",
    value_es: "",
  });
  const [newCategory, setNewCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");

  const fetchMachineDetails = async () => {
    const response = await fetch(`/api/machine/${id}`);
    const data = await response.json();
    setMachine(data);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await fetch("/api/category");
      const data = await response.json();
      setCategories(data);
    };

    fetchCategories();
    fetchMachineDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleUpdateMachine = async (e) => {
    e.preventDefault();
    const updatedMachine = {
      ...machine,
      [e.target.name]: e.target.value,
    };
    setMachine(updatedMachine);

    try {
      const response = await fetch(`/api/machine/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedMachine),
      });
      const data = await response.json();
      if (response.status !== 200) {
        setError(data.detail);
        return;
      }
      setError("");
    } catch (error) {
      console.error("Error updating machine:", error);
    }
  };

  const handleAddOption = async () => {
    try {
      const response = await fetch(`/api/machine/${id}/options`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newOption),
      });
      const data = await response.json();
      if (response.status !== 200) {
        setError(data.detail);
        return;
      }
      setError("");
      setNewOption({
        name_en: "",
        name_fr: "",
        name_de: "",
        name_it: "",
        name_es: "",
        value_en: "",
        value_fr: "",
        value_de: "",
        value_it: "",
        value_es: "",
      });
      setMachine({ ...machine, options: [...machine.options, newOption] });
      window.location.reload();
    } catch (error) {
      console.error("Error adding option:", error);
    }
  };

  const handleUpdateAdvantage = async (advantage, e) => {
    e.preventDefault();
    const updatedAdvantage = {
      ...advantage,
      [e.target.name]: e.target.value,
    };
    setMachine({
      ...machine,
      advantages: machine.advantages.map((adv) =>
        adv.id === advantage.id ? updatedAdvantage : adv
      ),
    });

    try {
      const response = await fetch(
        `/api/machine/${id}/advantages/${advantage.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedAdvantage),
        },
      );
      const data = await response.json();
      if (response.status !== 200) {
        setError(data.detail);
        return;
      }
      if (e.target.name === "priority") {
        fetchMachineDetails();
        return;
      }
      setError("");
    } catch (error) {
      console.error("Error updating advantage:", error);
    }
  };

  const handleUpdateOptions = async (
    option,
    e,
  ) => {
    e.preventDefault();
    const updatedOption = {
      ...option,
      [e.target.name]: e.target.value,
    };
    setMachine({
      ...machine,
      options: machine.options.map((opt) =>
      opt.id === option.id ? updatedOption : opt
      ),
    });

    try {
      const response = await fetch(
        `/api/machine/${id}/options/${option.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedOption),
        },
      );
      const data = await response.json();
      if (response.status !== 200) {
        setError(data.detail);
        return;
      }
      if (e.target.name === "priority") {
        fetchMachineDetails();
        return;
      }
      setError("")
    } catch (error) {
      console.error("Error updating option:", error);
    }
  };

  const handleUpdateTechnicalCharacteristic = async (characteristic, e) => {
    e.preventDefault();
    const updatedCharacteristic = {
      ...characteristic,
      [e.target.name]: e.target.value,
    };
    setMachine({
      ...machine,
      technical_characteristics: machine.technical_characteristics.map((char) =>
      char.id === characteristic.id ? updatedCharacteristic : char
      ),
    });

    try {
      const response = await fetch(
        `/api/machine/${id}/technical-characteristics/${characteristic.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedCharacteristic),
        },
      );
      const data = await response.json();
      if (response.status !== 200) {
        setError(data.detail);
        return;
      }
      if (e.target.name === "priority") {
        fetchMachineDetails();
        return;
      }
      setError("");
    } catch (error) {
      console.error(
        "Error updating technical characteristic:",
        error,
      );
    }
  }

  if (!machine) {
     return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      <button
        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-4"
        type="button"
        onClick={() => (window.location.href = "/admin/machine")}
      >
        Go Back
      </button>
      <h1 className="text-2xl font-bold mb-4">{machine.name} Details</h1>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <form>
        <h2 className="text-xl font-bold mb-2">Edit Machine Details</h2>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="name"
          >
            Name (English)
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name_en"
            name="name_en"
            type="text"
            value={machine.name_en}
            onChange={(e) => handleUpdateMachine(e)}
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="name_fr"
          >
            Name (French)
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name_fr"
            name="name_fr"
            type="text"
            value={machine.name_fr}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="name_de"
          >
            Name (German)
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name_de"
            name="name_de"
            type="text"
            value={machine.name_de}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="name_it"
          >
            Name (Italian)
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name_it"
            type="text"
            name="name_it"
            value={machine.name_it}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="name_es"
          >
            Name (Spanish)
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name_es"
            name="name_es"
            type="text"
            value={machine.name_es}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="description"
          >
            Description (English)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="description_en"
            name="description_en"
            value={machine.description_en}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="description_fr"
          >
            Description (French)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="description_fr"
            name="description_fr"
            value={machine.description_fr}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="description_de"
          >
            Description (German)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="description_de"
            name="description_de"
            value={machine.description_de}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="description_it"
          >
            Description (Italian)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="description_it"
            name="description_it"
            value={machine.description_it}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="description_es"
          >
            Description (Spanish)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="description_es"
            name="description_es"
            value={machine.description_es}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="metadescription_en"
          >
            Meta Description (English)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="metadescription_en"
            name="metadescription_en"
            value={machine.metadescription_en}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="metadescription_fr"
          >
            Meta Description (French)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="metadescription_fr"
            name="metadescription_fr"
            value={machine.metadescription_fr}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="metadescription_de"
          >
            Meta Description (German)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="metadescription_de"
            name="metadescription_de"
            value={machine.metadescription_de}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="metadescription_it"
          >
            Meta Description (Italian)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="metadescription_it"
            name="metadescription_it"
            value={machine.metadescription_it}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="metadescription_es"
          >
            Meta Description (Spanish)
          </label>
          <textarea
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="metadescription_es"
            name="metadescription_es"
            value={machine.metadescription_es}
            onChange={(e) =>
              handleUpdateMachine(e)
            }
          />
        </div>
      </form>
      <button
        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        type="button"
        onClick={async () => {
          try {
            if (
              !window.confirm("Are you sure you want to delete this machine?")
            ) {
              return;
            }
            await fetch(`/api/machine/${id}`, {
              method: "DELETE",
            });
            window.location.href = "/admin/machine";
          } catch (error) {
            console.error("Error deleting machine:", error);
          }
        }}
      >
        Delete Machine
      </button>

      <hr className="my-10" />

      <h2 className="text-xl font-bold mb-2">Categories</h2>

      <div className="mb-4">
        <h3 className="text-lg font-bold mb-2">Add Category</h3>
        <div className="flex mb-2">
          <select
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
          >
            <option value="">Select a Category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
          <button
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="button"
            onClick={async () => {
              try {
                const response = await fetch(`/api/machine/${id}/category`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ id: newCategory }),
                });
                const data = await response.json();
                if (response.status !== 200) {
                  setError(data.detail);
                  return;
                }
                setError("");
                setNewCategory("");
                setMachine({
                  ...machine,
                  categories: [
                    ...machine.categories,
                    {
                      id: newCategory,
                      name: categories.find(
                        (category) => category.id === newCategory,
                      ).name,
                    },
                  ],
                });
                window.location.reload();
              } catch (error) {
                console.error("Error adding category:", error);
              }
            }}
          >
            Add Category
          </button>
        </div>
      </div>

      <table className="categories table-auto w-full mb-4">
        <thead>
          <tr>
            <th className="px-4 py-2">Name</th>
            <th className="px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {machine.categories.map((category, index) => (
            <tr key={index}>
              <td className="border px-4 py-2">{category.name}</td>
              <td className="border px-4 py-2">
                <button
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={async () => {
                    try {
                      if (
                        !window.confirm(
                          "Are you sure you want to remove this categorie?",
                        )
                      ) {
                        return;
                      }
                      await fetch(`/api/machine/${id}/category`, {
                        method: "DELETE",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ id: category.id }),
                      });
                      setMachine({
                        ...machine,
                        categories: machine.categories.filter(
                          (_, i) => i !== index,
                        ),
                      });
                    } catch (error) {
                      console.error("Error deleting category:", error);
                    }
                  }}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr className="my-10" />

      <h2 className="text-xl font-bold mb-2">Advantages</h2>

      <div className="mb-4">
        <h3 className="text-lg font-bold mb-2">Add Advantage</h3>
        <div className="flex mb-2">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Advantage Description (English)"
            value={newAdvantage.description_en}
            onChange={(e) =>
              setNewAdvantage({
                ...newAdvantage,
                description_en: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Advantage Description (French)"
            value={newAdvantage.description_fr}
            onChange={(e) =>
              setNewAdvantage({
                ...newAdvantage,
                description_fr: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Advantage Description (German)"
            value={newAdvantage.description_de}
            onChange={(e) =>
              setNewAdvantage({
                ...newAdvantage,
                description_de: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Advantage Description (Italian)"
            value={newAdvantage.description_it}
            onChange={(e) =>
              setNewAdvantage({
                ...newAdvantage,
                description_it: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Advantage Description (Spanish)"
            value={newAdvantage.description_es}
            onChange={(e) =>
              setNewAdvantage({
                ...newAdvantage,
                description_es: e.target.value,
              })
            }
          />
        </div>
        <button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          onClick={async () => {
            try {
              const response = await fetch(`/api/machine/${id}/advantages`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(newAdvantage),
              });
              const data = await response.json();
              if (response.status !== 200) {
                setError(data.detail);
                return;
              }
              setError("");
              setNewAdvantage({
                description_en: "",
                description_fr: "",
                description_de: "",
                description_it: "",
                description_es: "",
              });
              setMachine({
                ...machine,
                advantages: [...machine.advantages, newAdvantage],
              });
              window.location.reload();
            } catch (error) {
              console.error("Error adding advantage:", error);
            }
          }}
        >
          Add Advantage
        </button>
      </div>

      <table className="advantages table-auto w-full mb-4">
        <thead>
          <tr>
            <th className="px-4 py-2">Description (English)</th>
            <th className="px-4 py-2">Description (French)</th>
            <th className="px-4 py-2">Description (German)</th>
            <th className="px-4 py-2">Description (Italian)</th>
            <th className="px-4 py-2">Description (Spanish)</th>
            <th className="px-4 py-2">Priority</th>
            <th className="px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {machine.advantages.map((advantage, index) => (
            <tr key={index}>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="description_en"
                  value={advantage.description_en}
                  onChange={(e) => handleUpdateAdvantage(advantage, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="description_fr"
                  value={advantage.description_fr}
                  onChange={(e) => handleUpdateAdvantage(advantage, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="description_de"
                  value={advantage.description_de}
                  onChange={(e) => handleUpdateAdvantage(advantage, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="description_it"
                  value={advantage.description_it}
                  onChange={(e) => handleUpdateAdvantage(advantage, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="description_es"
                  value={advantage.description_es}
                  onChange={(e) => handleUpdateAdvantage(advantage, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="number"
                  name="priority"
                  value={advantage.priority || ""}
                  onChange={(e) => handleUpdateAdvantage(advantage, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <button
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={async () => {
                    try {
                      if (
                        !window.confirm(
                          "Are you sure you want to delete this machine advantage?",
                        )
                      ) {
                        return;
                      }
                      await fetch(
                        `/api/machine/${id}/advantages/${advantage.id}`,
                        {
                          method: "DELETE",
                        },
                      );
                      setMachine({
                        ...machine,
                        advantages: machine.advantages.filter(
                          (_, i) => i !== index,
                        ),
                      });
                    } catch (error) {
                      console.error("Error deleting advantage:", error);
                    }
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr className="my-10" />

      <h2 className="text-xl font-bold mb-2">Options</h2>

      <div className="mb-4">
        <h3 className="text-lg font-bold mb-2">Add Option</h3>
        <div className="flex mb-2">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Name (English)"
            value={newOption.name_en}
            onChange={(e) =>
              setNewOption({ ...newOption, name_en: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Name (French)"
            value={newOption.name_fr}
            onChange={(e) =>
              setNewOption({ ...newOption, name_fr: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Name (German)"
            value={newOption.name_de}
            onChange={(e) =>
              setNewOption({ ...newOption, name_de: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Name (Italian)"
            value={newOption.name_it}
            onChange={(e) =>
              setNewOption({ ...newOption, name_it: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Option Name (Spanish)"
            value={newOption.name_es}
            onChange={(e) =>
              setNewOption({ ...newOption, name_es: e.target.value })
            }
          />
        </div>
        <div className="flex mb-2">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Value (English)"
            value={newOption.value_en}
            onChange={(e) =>
              setNewOption({ ...newOption, value_en: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Value (French)"
            value={newOption.value_fr}
            onChange={(e) =>
              setNewOption({ ...newOption, value_fr: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Value (German)"
            value={newOption.value_de}
            onChange={(e) =>
              setNewOption({ ...newOption, value_de: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Option Value (Italian)"
            value={newOption.value_it}
            onChange={(e) =>
              setNewOption({ ...newOption, value_it: e.target.value })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Option Value (Spanish)"
            value={newOption.value_es}
            onChange={(e) =>
              setNewOption({ ...newOption, value_es: e.target.value })
            }
          />
        </div>
        <button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          onClick={handleAddOption}
        >
          Add Option
        </button>
      </div>

      <table className="options table-auto w-full mb-4">
        <thead>
          <tr>
            <th className="px-4 py-2">Name (English)</th>
            <th className="px-4 py-2">Name (French)</th>
            <th className="px-4 py-2">Name (German)</th>
            <th className="px-4 py-2">Name (Italian)</th>
            <th className="px-4 py-2">Name (Spanish)</th>
            <th className="px-4 py-2">Value (English)</th>
            <th className="px-4 py-2">Value (French)</th>
            <th className="px-4 py-2">Value (German)</th>
            <th className="px-4 py-2">Value (Italian)</th>
            <th className="px-4 py-2">Value (Spanish)</th>
            <th className="px-4 py-2">Priority</th>
            <th className="px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {machine.options.map((option, index) => (
            <tr key={index}>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_en"
                  value={option.name_en}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_fr"
                  value={option.name_fr}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_de"
                  value={option.name_de}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_it"
                  value={option.name_it}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_es"
                  value={option.name_es}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_en"
                  value={option.value_en}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_fr"
                  value={option.value_fr}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_de"
                  value={option.value_de}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_it"
                  value={option.value_it}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_es"
                  value={option.value_es}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="number"
                  name="priority"
                  value={option.priority || ""}
                  onChange={(e) => handleUpdateOptions(option, e)}
                />
              </td>
              <td className="border px-4 py-2">
                <button
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={async () => {
                    try {
                      if (
                        !window.confirm(
                          "Are you sure you want to delete this machine option?",
                        )
                      ) {
                        return;
                      }
                      await fetch(`/api/machine/${id}/options/${option.id}`, {
                        method: "DELETE",
                      });
                      setMachine({
                        ...machine,
                        options: machine.options.filter((_, i) => i !== index),
                      });
                    } catch (error) {
                      console.error("Error deleting option:", error);
                    }
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr className="my-10" />

      <h2 className="text-xl font-bold mb-2">Technical Characteristics</h2>

      <div className="mb-4">
        <h3 className="text-lg font-bold mb-2">Add Technical Characteristic</h3>
        <div className="flex mb-2">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Name (English)"
            value={newTechnicalCharacteristic.name_en}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                name_en: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Name (French)"
            value={newTechnicalCharacteristic.name_fr}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                name_fr: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Name (German)"
            value={newTechnicalCharacteristic.name_de}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                name_de: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Name (Italian)"
            value={newTechnicalCharacteristic.name_it}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                name_it: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Characteristic Name (Spanish)"
            value={newTechnicalCharacteristic.name_es}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                name_es: e.target.value,
              })
            }
          />
        </div>
        <div className="flex mb-2">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Value (English)"
            value={newTechnicalCharacteristic.value_en}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                value_en: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Value (French)"
            value={newTechnicalCharacteristic.value_fr}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                value_fr: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Value (German)"
            value={newTechnicalCharacteristic.value_de}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                value_de: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="text"
            placeholder="Characteristic Value (Italian)"
            value={newTechnicalCharacteristic.value_it}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                value_it: e.target.value,
              })
            }
          />
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Characteristic Value (Spanish)"
            value={newTechnicalCharacteristic.value_es}
            onChange={(e) =>
              setNewTechnicalCharacteristic({
                ...newTechnicalCharacteristic,
                value_es: e.target.value,
              })
            }
          />
        </div>
        <button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          onClick={async () => {
            try {
              const response = await fetch(
                `/api/machine/${id}/technical-characteristics`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(newTechnicalCharacteristic),
                },
              );
              const data = await response.json();
              if (response.status !== 200) {
                setError(data.detail);
                return;
              }
              setError("");
              setNewTechnicalCharacteristic({
                name_en: "",
                name_fr: "",
                name_de: "",
                name_it: "",
                name_es: "",
                value_en: "",
                value_fr: "",
                value_de: "",
                value_it: "",
                value_es: "",
              });
              setMachine(data);
              window.location.reload();
            } catch (error) {
              console.error("Error adding technical characteristic:", error);
            }
          }}
        >
          Add Technical Characteristic
        </button>
      </div>

      <table className="technical-characteristics table-auto w-full mb-4">
        <thead>
          <tr>
            <th className="px-4 py-2">Name (English)</th>
            <th className="px-4 py-2">Name (French)</th>
            <th className="px-4 py-2">Name (German)</th>
            <th className="px-4 py-2">Name (Italian)</th>
            <th className="px-4 py-2">Name (Spanish)</th>
            <th className="px-4 py-2">Value (English)</th>
            <th className="px-4 py-2">Value (French)</th>
            <th className="px-4 py-2">Value (German)</th>
            <th className="px-4 py-2">Value (Italian)</th>
            <th className="px-4 py-2">Value (Spanish)</th>
            <th className="px-4 py-2">Priority</th>
            <th className="px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {machine.technical_characteristics.map((characteristic, index) => (
            <tr key={index}>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_en"
                  value={characteristic.name_en}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_fr"
                  value={characteristic.name_fr}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_de"
                  value={characteristic.name_de}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_it"
                  value={characteristic.name_it}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="name_es"
                  value={characteristic.name_es}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_en"
                  value={characteristic.value_en}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_fr"
                  value={characteristic.value_fr}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_de"
                  value={characteristic.value_de}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_it"
                  value={characteristic.value_it}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  name="value_es"
                  value={characteristic.value_es}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  className="w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  type="number"
                  name="priority"
                  value={characteristic.priority || ""}
                  onChange={(e) => {
                    handleUpdateTechnicalCharacteristic(
                      characteristic,
                      e
                    )
                  }}
                />
              </td>
              <td className="border px-4 py-2">
                <button
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={async () => {
                    try {
                      if (
                        !window.confirm(
                          "Are you sure you want to delete this machine technical characteristic?",
                        )
                      ) {
                        return;
                      }
                      await fetch(
                        `/api/machine/${id}/technical-characteristics/${characteristic.id}`,
                        {
                          method: "DELETE",
                        },
                      );
                      setMachine({
                        ...machine,
                        technical_characteristics:
                          machine.technical_characteristics.filter(
                            (_, i) => i !== index,
                          ),
                      });
                    } catch (error) {
                      console.error(
                        "Error deleting technical characteristic:",
                        error,
                      );
                    }
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr className="my-10" />

      <h2 className="text-xl font-bold mb-2">Pictures</h2>

      <div className="mb-4">
        <h3 className="text-lg font-bold mb-2">Add Picture or videos</h3>
        <div className="flex mb-2">
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2"
            type="file"
            accept="image/*,video/*"
            onChange={async (e) => {
              const file = e.target.files[0];
              const reader = new FileReader();
              reader.onloadend = async () => {
                const base64String = reader.result
                  .replace("data:", "")
                  .replace(/^.+,/, "");
                try {
                  const response = await fetch(`/api/machine/${id}/picture`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ image: base64String, type: file.type }),
                  });
                  const data = await response.json();
                  if (response.status !== 200) {
                    setError(data.detail);
                    return;
                  }
                  setError("");
                  setMachine({
                    ...machine,
                    pictures: [
                      ...machine.pictures,
                      { url: data.url, description: data.description, type: file.type },
                    ],
                  });
                } catch (error) {
                  console.error("Error adding picture:", error);
                }
              };
              reader.readAsDataURL(file);
            }}
          />
        </div>
      </div>

      <div className="flex flex-wrap">
        {machine.pictures.map((picture, index) => (
          <div key={index} className="m-2 relative">
            {(picture.type ?? "").startsWith("video/") ? (
              <video
                src={picture.url}
                controls
                className="w-48 h-48 object-cover"  
              />
            ) : (
            <img
              src={picture.url}
              alt={picture.description}
              className="w-48 h-48 object-cover"
            />)}
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={async () => {
                try {
                  if (
                    !window.confirm(
                      "Are you sure you want to delete this machine picture ?",
                    )
                  ) {
                    return;
                  }
                  await fetch(`/api/machine/${id}/picture/${picture.id}`, {
                    method: "DELETE",
                  });
                  setMachine({
                    ...machine,
                    pictures: machine.pictures.filter((_, i) => i !== index),
                  });
                } catch (error) {
                  console.error("Error deleting picture:", error);
                }
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MachineManagementDetails;
